/** Public browser route submitted to Google Play for account deletion. */
export const ACCOUNT_DELETION_PATH = "/account-deletion";
